/**
 * This event is fired when the user has no consent or invalid consent
 * and the banner gets visible (but in `document.readyState === "interactive"` state).
 */ export const BANNER_PRE_DECISION_SHOW_INTERACTIVE_EVENT = "RCB/Banner/Show/Interactive";
